<div class="interest__menu">
  <div class="menu-container">
    <div class="menu-title">{{"teInteresa" | transloco}}</div>
    <ul class="menu-content">
      <li class="menu-item"><a target="_blank" href="https://www.realbetisbalompie.es/entradas/">{{"entradas" | transloco}}</a></li>
      <li class="menu-item"><a href="socios/hazte-socio/palmerin">Soy Palmerín</a></li>
      <li class="menu-item"><a href="socios/hazte-socio/soy-betico">Soy Bético</a></li>
      <li class="menu-item"><a href="socios/hazte-socio/soy-betico-digital">Soy Bético Digital</a></li>
      <li class="menu-item"><a target="_blank" href="https://www.realbetisbalompie.es/rtvbetis/directo-tv/">Real Betis Tv</a></li>
      <li class="menu-item"><a target="_blank" href="https://ticketbetis.realbetisbalompie.es/realbetisbalompie_tour/es_ES">Tour</a></li>
      <li class="menu-item"><a target="_blank" href="https://shop.realbetisbalompie.es/">{{"tienda" | transloco}}</a></li>
      <li class="menu-item"><a href="socios#faqs__component" title="Preguntas frecuentes">FAQs</a></li>
    </ul>
  </div>
  <div class="menu-container">
    <div class="menu-title">{{"equipos" | transloco}}</div>
    <ul class="menu-content">
      <li class="menu-item"><a target="_blank" href="https://www.realbetisbalompie.es/primer-equipo/portada/">{{"primerEquipo" | transloco}}</a></li>
      <li class="menu-item"><a target="_blank" href="https://www.realbetisbalompie.es/feminas/portada/">{{"feminas" | transloco}}</a></li>
      <!--li class="menu-item"><a target="_blank" href="https://www.realbetisbalompie.es/baloncesto/">{{"baloncesto" | transloco}}</a></li-->
      <!--li class="menu-item"><a target="_blank" href="https://www.realbetisbalompie.es/futsal/portada/">Futsal</a></li-->
      <li class="menu-item"><a target="_blank" href="https://www.realbetisbalompie.es/cantera/portada/">{{"cantera" | transloco}}</a></li>
      <!--li class="menu-item"><a target="_blank" href="https://www.realbetisbalompie.es/esports/">Esports</a></li-->
    </ul>
  </div>
  <div class="menu-container">
    <div class="menu-title">{{"descargaNuestraApp" | transloco}}</div>
    <ul class="menu-content">
      <li class="menu-item">
        <a target="_blank"  href="https://play.google.com/store/apps/details?id=com.betis.app&pli=1">
          <img src="/assets/images/Google-play.webp" alt="Descargar android APP">
        </a>
      </li>
      <li class="menu-item">
        <a target="_blank" href="https://itunes.apple.com/es/app/id1392232716?mt=8">
          <img src="/assets/images/Apple-store.webp" alt="Descargar iOS APP">
        </a>
      </li>
    </ul>
  </div>
</div>
